import { useEffect } from "react";

/**
 * Uses an effect with an async cancellation signal.
 */
export function useAsyncEffect(effect, deps) {
  useEffect(() => {
    let canceled = false;
    effect({
      isCanceled() {
        return canceled;
      }
    });
    return () => {
      canceled = true;
    };
  }, deps);
}